import { useEffect, useState } from "react";
import { MenuCategoryRevenueStats } from "../../../../../services/stats/models";
import { getRevenueStatsByMenuCategoryId } from "../../../../../services/stats";

interface IFilter {
    fromDate: Date,
    toDate: Date,
    limit: number,
    menuId: number
}
const useTopCategoriesStatsFetcher = (): [boolean, MenuCategoryRevenueStats[], IFilter, (v: IFilter) => void] => {
    const [isLoading, setIsLoading] = useState(true);
    const [result, setResult] = useState<MenuCategoryRevenueStats[]>([]);
    const [filter, setFilter] = useState<IFilter>();

    useEffect(() => {
        if(!filter) return;
        setIsLoading(true);
        (async () => {
            const res = await getRevenueStatsByMenuCategoryId(filter);
            if(!res.err){
                setResult(res.revenues);
            }
            setIsLoading(false);
        })()
    }, [filter])

    return [isLoading, result, filter, setFilter];
};


export default useTopCategoriesStatsFetcher;
